import { render, staticRenderFns } from "./storeTender.vue?vue&type=template&id=2c374a6d&scoped=true&"
import script from "./storeTender.vue?vue&type=script&lang=js&"
export * from "./storeTender.vue?vue&type=script&lang=js&"
import style0 from "./storeTender.vue?vue&type=style&index=0&id=2c374a6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c374a6d",
  null
  
)

export default component.exports